import React, { useEffect, useState } from 'react'
import { FaSearch, FaList, FaPlus, FaInbox, FaCodeBranch } from "react-icons/fa";
import { useLocation } from 'react-router';
import ProjectAdminList from './ProjectAdminList';
import ProjectAdminRead from './ProjectAdminRead';
import ProjectAdminEdit from './ProjectAdminEdit';
import ProjectAdminCreate from './ProjectAdminCreate';

function ProjectAdmin() {

  const location = useLocation()
    const [activeAction,setActiveAction] = useState("list-projects")
  
    const navItems = [
      { label: 'Create Project',  path: '/staff/project/create',tab:'create-project' },
      { label: 'Project',  path: '/staff/project/detail',tab:'project-detail-view'  },
      { label: 'Edit Project',  path: '/staff/project/edit',tab:'edit-project' },
      { label: 'List Projects',  path: '/staff/projects',tab:'list-projects' },
    ];
  
    
  
     useEffect(()=>{
        // console.log(location)
        if(location?.pathname==="/staff/project/create/" && activeAction !== "create-project"){
          setActiveAction("create-project")
        }else if(location?.pathname.includes("/staff/project/detail/") && activeAction !== "project-detail-view"){
          setActiveAction("project-detail-view")
        }else if(location?.pathname==="/staff/project/edit/" && activeAction !== "edit-project"){
          setActiveAction("edit-project")
        }else if(location?.pathname==="/staff/projects/" && activeAction !== "list-projects"){
          setActiveAction("list-projects")
        }
      },[location])

       useEffect(()=>{
        if(location?.state?.redirect){
          setActiveAction(location?.state?.redirect)
        }
      },[location])
  
      const CreateProject = (e)=>{
        e.preventDefault()
        setActiveAction("create-project")
      }
  
      const EditProject = (e)=>{
        e.preventDefault()
        setActiveAction("edit-project")
      }
  
      const ListProjects = (e)=>{
        e.preventDefault()
        setActiveAction("list-projects")
      }
  

      const views = {
        "create-project":<ProjectAdminCreate/>,
        "edit-project":<ProjectAdminEdit/>,
        "project-detail-view":<ProjectAdminRead/>,
        "list-projects": <ProjectAdminList/>
      }


  return (
    <div>
        {/* <h3>ProjectAdmin</h3> */}
    <header className="projects-header-admin">
      <h1 className="header-title-admin">Projects DashBoard</h1>

      <div className="header-controls-admin">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Type / to search"
            className="search-input"
          />
        </div>

        <div className="icon-group">
          <button className="icon-button tooltip-container" onClick={CreateProject}>
            <FaPlus /> <span>New Project</span> <span class="tooltip-content">New Project</span>
          </button>
          <button className="icon-button tooltip-container" onClick={ListProjects}>
            <FaList /> <span>View Projects</span> <span class="tooltip-content">List All Projects</span>
          </button>
          <button className="icon-button">
            <FaCodeBranch />
          </button>
          <button className="icon-button">
            <FaInbox />
          </button>
        </div>
      </div>
    </header>

    <div>
        {
          views[activeAction] || views['list-projects']
        }
    </div>
    </div>
  )
}

export default ProjectAdmin